import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LspAdvShipIndexActions, { LspAdvShipIndexTypes } from '../Stores/LspAdvShipIndex/Actions';

const getAppStore = state => state.app;

export function* lspAdvShipIndexFetchLspAdvShipIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LspAdvShipIndexActions.lspAdvShipIndexFetchLspAdvShipIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `lspAdvShip/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LspAdvShipIndexActions.lspAdvShipIndexFetchLspAdvShipIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspAdvShipIndexActions.lspAdvShipIndexFetchLspAdvShipIndexLoading(false));
  }
}

export function* lspAdvShipIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspAdvShipDetail/update/${hdrId}`));
}

export function* lspAdvShipIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/LSP_ADV_SHIP/${hdrId}/LspAdvShipHdr`));
}

export const saga = [
  takeLatest(LspAdvShipIndexTypes.LSP_ADV_SHIP_INDEX_GO_TO_DOCUMENT, lspAdvShipIndexGoToDocument),
  takeLatest(LspAdvShipIndexTypes.LSP_ADV_SHIP_INDEX_GO_TO_AUDIT, lspAdvShipIndexGoToAudit),
  takeLatest(
    LspAdvShipIndexTypes.LSP_ADV_SHIP_INDEX_FETCH_LSP_ADV_SHIP_INDEX,
    lspAdvShipIndexFetchLspAdvShipIndex
  )
];
